import { render, staticRenderFns } from "./EditSosDialog.vue?vue&type=template&id=2980e4af&"
import script from "./EditSosDialog.vue?vue&type=script&lang=ts&"
export * from "./EditSosDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports